module.exports = "/_next/static/images/plane2-monotone-be0a5c26f4922d9223d1b33532c6c1a4.svg";